import { TemplateModel } from '@/components/ui';

import { dateFormatter, highConfidenceValidator } from './common.ts';

export const W9_TAX_FORM: TemplateModel = {
  fields: [
    {
      id: 'name',
      type: 'single-value',
      name: 'Name',
      promptHint: 'First and last name.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'address',
      type: 'single-value',
      name: 'Address',
      promptHint: 'The address. Number, street, apt. or suite no.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'city',
      type: 'single-value',
      name: 'City',
      promptHint: 'The city, state and ZIP code.',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'ssn',
      type: 'single-value',
      name: 'Social Security Number',
      promptHint: 'The social security number. 9 digits.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'employer_id',
      type: 'single-value',
      name: 'Employer Identification Number',
      promptHint: 'The employer identification number (EIN)',
      validators: [highConfidenceValidator],
    },
    {
      id: 'signature_date',
      type: 'single-value',
      name: 'Signature date',
      promptHint: 'Date of signature',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
  ],
  sampleDocuments: ['https://public.cradl.ai/sample_documents/W9_Tax_Form.pdf'],
};
